module.exports = __webpack_public_path__ + "img/22_30.7e74a218.png";